(ns manatee.admin.subs
  (:require [cljs-time.format :as tf]
            [clojure.set :refer [rename-keys]]
            [manatee.admin.app-db :as admin-db]
            [medley.core :refer [find-first]]
            [re-frame.core :as rf]))

(rf/reg-sub
 ::users
 (fn users
   [db _]
   (->> (admin-db/get-users db)
        (sort-by (juxt :last-name :first-name :email)))))

(rf/reg-sub
 ::adding-user?
 (fn adding-user?
   [db _]
   (admin-db/get-adding-user? db)))

(rf/reg-sub
 ::user-teams
 (fn [db _]
   (->> (admin-db/get-user-teams db)
        (map #(rename-keys % {:id :value, :name :representation})))))

(rf/reg-sub
 ::active-users
 :<- [::users]
 (fn users
   [users _]
   (->> users
        (filter :is-active)
        (sort-by (juxt :last-name :first-name :email)))))

(rf/reg-sub
 ::selected-user
 :<- [::users]
 (fn selected-user
   [users _]
   (find-first :selected? users)))

(rf/reg-sub
 ::selected-tab
 (fn selected-tab
   [db _]
   (or (admin-db/selected-tab db) :users)))

(rf/reg-sub
 ::raw-messages
 (fn [db _]
   (admin-db/get-messages db)))

(rf/reg-sub
 ::messages
 :<- [::raw-messages]
 (fn [raw-messages _]
   (->> raw-messages
        (map (fn [msg] (let [{:keys [start-time end-time]} msg
                             disp-formatter (tf/formatter "HH:mm' GMT, 'dd/MMM/yyyy")]
                         (-> msg
                             (assoc :disp-start-time (tf/unparse disp-formatter start-time))
                             (assoc :disp-end-time (tf/unparse disp-formatter end-time))
                             (assoc :edit-start-time (admin-db/format-editable-time start-time))
                             (assoc :edit-end-time (admin-db/format-editable-time end-time))))))
        (sort-by (comp str :start-time)))))

(rf/reg-sub
 ::selected-message
 :<- [::messages]
 (fn selected-message
   [messages _]
   (find-first :selected? messages)))

(rf/reg-sub
 ::task-summary
 (fn task-summary
   [db _]
   (admin-db/get-task-summary db)))

(rf/reg-sub
 ::user-guide-payload
 (fn user-guide-payload
   [db _]
   (admin-db/get-user-guide-payload db)))
